<template>
  <div
    class="mode__button-container"
    :class="[{'hide-in-app': isInApp}, {'hide-in-navbar': isInNavbar}]">
    <div class="wrapper">
      <label class="switch">
        <input type="checkbox" v-model="isDarkMode" @click="toggleDarkMode" />
        <span class="slider round">
          <div class="image-container">
            <div class="moon-container">
              <img
                src="../assets/moon.png"
                alt="moon"
                class="slider-image moon" />
            </div>
            <div class="sun-container">
              <img src="../assets/sun.png" alt="sun" class="slider-image sun" />
            </div>
          </div>
        </span>
      </label>
    </div>
  </div>
  <div></div>
</template>

<script setup lang="ts">
import store from '@/store';
import {defineProps, onMounted, ref} from 'vue';

defineProps({
  isInApp: Boolean,
  isInNavbar: Boolean,
});

const isDarkMode = ref(true);

const toggleDarkMode = () => {
  updateTheme(!isDarkMode.value);
};

const updateTheme = (value: boolean) => {
  isDarkMode.value = value;
  store.dispatch('setIsDarkMode', value);
  sessionStorage.setItem('isDarkMode', value.toString());
  if (value) {
    document.body.classList.add('dark-mode');
    document.body.classList.remove('light-mode');
  } else {
    document.body.classList.add('light-mode');
    document.body.classList.remove('dark-mode');
  }
};

onMounted(() => {
  const darkMode = sessionStorage.getItem('isDarkMode');
  updateTheme(darkMode === 'false' ? false : true);
});
</script>

<style lang="scss" scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 80px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #424141;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: var(--transition-time);
    transition: var(--transition-time);
  }

  input:checked + .slider {
    background-color: var(--dark-mode-bg);
  }

  input:focus + .slider {
    box-shadow: 0 0 1px var(--dark-mode-bg);
  }

  input:checked + .slider:before {
    -webkit-transform: translateY(-45px);
    -ms-transform: translateY(-45px);
    transform: translateY(-45px);
  }

  .slider.round {
    border-radius: 34px;
  }
  .slider.round:before {
    border-radius: 50%;
  }

  .slider-image {
    width: 26px !important;
    height: 26px !important;
    transition: opacity var(--transition-time);
  }

  input:checked + .slider .moon,
  input:not(:checked) + .slider .sun {
    opacity: 0;
  }
}

@media screen and (min-width: 700px) {
  .hide-in-navbar {
    display: none;
  }

  .mode__button-container {
    position: sticky;
    top: 50%;

    .wrapper {
      position: absolute;
      right: 5px;
      transform: translateY(-50%);
      padding: 5px;
      border-radius: 50%;
    }

    .image-container {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 70px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
    }
  }
}

@media screen and (max-width: 699px) {
  .hide-in-app {
    display: none;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 80px;
    height: 34px;

    input:checked + .slider:before {
      -webkit-transform: translateX(45px);
      -ms-transform: translateX(45px);
      transform: translateX(45px);
    }

    .image-container {
      position: absolute;
      width: 80%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .moon-container {
        order: 2;
      }
      .sun-container {
        order: 1;
      }
    }
  }
}
</style>
